import styled from 'styled-components';

export const DetailsMainWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.grey.lightf2};
  `
)